import { render, staticRenderFns } from "./ready_to_merge.vue?vue&type=template&id=ac85205e&"
import script from "./ready_to_merge.vue?vue&type=script&lang=js&"
export * from "./ready_to_merge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports